import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from './UserAvatar';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { isGroup as getIsGroup } from '../helpers';
import { BiData } from '@wix/da-bi/pkg/events';
export const UserAvatarWithPopover = (_param)=>{
    var { withTooltip, user, className, biData, relatedItemBiData } = _param, props = _object_without_properties(_param, [
        "withTooltip",
        "user",
        "className",
        "biData",
        "relatedItemBiData"
    ]);
    const isMobile = useContext(MobileContext);
    const isGroup = user && getIsGroup(user);
    const shouldRenderTooltip = withTooltip && !isMobile && !isGroup;
    if (!shouldRenderTooltip || !user) {
        return /*#__PURE__*/ React.createElement(UserAvatar, _object_spread({
            user: user,
            className: className,
            biData: biData
        }, props));
    }
    return /*#__PURE__*/ React.createElement(UserAvatarPopover, {
        username: user.username,
        className: className,
        relatedItemBiData: relatedItemBiData,
        biData: BiData(_object_spread_props(_object_spread({}, biData), {
            itemid: user.userId,
            typeid: isGroup ? ResourceType.GROUP : ResourceType.USER,
            evid: 107
        }))
    }, /*#__PURE__*/ React.createElement(UserAvatar, _object_spread({
        user: user,
        biData: biData
    }, props)));
};
UserAvatarWithPopover.displayName = 'UserAvatarWithPopover';
export default UserAvatarWithPopover;

//# sourceMappingURL=UserAvatarWithPopover.js.map